"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BannerMixin = void 0;
var _drywall = require("drywall");
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _spaceMixin = require("../spaceMixin");
// Push the close button to the far right
var closeButtonCSS = function closeButtonCSS(props) {
  var closeButton = props.closeButton;
  if (!closeButton) {
    return '';
  }
  return (0, _styledToken.default)({
    marginRight: 'Banner.withCloseButton.actionBodyMarginRight',
    marginLeft: 'Banner.withCloseButton.actionBodyMarginLeft'
  }, function (_ref) {
    var marginRight = _ref.marginRight,
      _ref$marginLeft = _ref.marginLeft,
      marginLeft = _ref$marginLeft === void 0 ? 0 : _ref$marginLeft;
    return (0, _styledComponents.css)(["", "{margin-left:auto;}", ",", "{margin-right:", ";margin-left:", "px;}", "{margin-left:auto;}"], _drywall.Toast.Icon, _drywall.Toast.Action, _drywall.Toast.Body, marginRight ? marginRight + "px" : (0, _spaceMixin.spaceMixin)('sm')(props), marginLeft, _drywall.Toast.Close);
  })(props);
};

/** @class BannerMixin */
/** @method */
var BannerMixin = function BannerMixin(props) {
  return (0, _styledToken.default)({
    borderRadius: "Banner.borderRadius",
    boxShadow: "Banner.boxShadow"
  }, function (_ref2) {
    var borderRadius = _ref2.borderRadius,
      boxShadow = _ref2.boxShadow;
    return (0, _styledComponents.css)(["display:flex;max-width:none;border-radius:", ";box-shadow:", ";justify-content:center;", ""], borderRadius || 0, boxShadow || 'none', closeButtonCSS(props));
  })(props);
};
exports.BannerMixin = BannerMixin;